export class ImageResolutionModel {
  id! :number;
  width!: number;
  height!: number;
}

export const IMAGE_RESOLUTIONS: ImageResolutionModel[] = [
  { id:1, width: 896, height: 1152 },
  { id:2, width: 1024, height: 1024 },
  { id:3, width: 1152, height: 896 },
  { id:4, width: 1344, height: 756 },
  { id:5, width: 1344, height: 768 },
  { id:6, width: 1792, height: 2304 },
  { id:7, width: 2048, height: 2048 },
  { id:8, width: 2304, height: 1792 },
  { id:9, width: 2688, height: 1536 },
  { id:10, width: 2688, height: 1512 }
];
